module.exports = __webpack_public_path__ + "static/media/image_part_006.ce22db21.jpg";